export const AUDIT_STATUS = {
    PENDING_AUDIT: [32]
};

export const SLA_TYPES = [
    { _id: 'totals', label: 'Resumen' },
    { _id: 'dad', label: 'Despacho a Domicilio', icon: 'despachoADomicilio' },
    { _id: 'de', label: 'Retiro En tienda', icon: 'retiroEnTienda' },
    { _id: 'raa', label: 'Retiro al Auto', icon: 'retiroAlAuto' }
];